// if (window.innerWidth < 550) {
document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('sectionDropdown').addEventListener('change', function() {
      const selectedValue = this.value;

      // Hide all sections
      document.querySelectorAll('.tabcontent_service').forEach(function(section) {
        section.style.display = 'none';
      });

      // Show the selected section
      document.getElementById(selectedValue).style.display = 'block';
    });
  });
// } else{
// function openService(evt, cityName) {
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tabcontent_service");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }
//   tablinks = document.getElementsByClassName("tablinks_service");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }
//   document.getElementById(cityName).style.display = "block";
//   evt.currentTarget.className += " active";
// }

// // Get the element with id="defaultOpen_service" and click on it
// document.getElementById("defaultOpen_service").click();
// }

